angular.module('CarsSaraBo').factory('SpecialOfferUrlsService', [
    function () {
        return {
            homeOffersUrl: function (companyOid) {
                return '/company/' + companyOid + '/specialoffer/';
            },
            newOfferUrl: function (companyOid, specialOfferType) {
                return this.homeOffersUrl(companyOid) + specialOfferType
            }
        };
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/special_offer_urls_service.js
// module id = 868
// module chunks = 3